import PropTypes from 'prop-types';
import React from 'react';

/**
 * @typedef {Object} ChatboxContainerProps
 * @property {React.ReactNode} children
 * @property {string} [title]
 * @property {string} [bodyClassName]
 */

/**
 * Chatbox container with header and body.
 * @component
 * @param {ChatboxContainerProps} props
 * @returns {JSX.Element}
 */
export default function ChatboxContainer({
  children,
  title = 'VA chatbot (beta)',
  bodyClassName = '',
}) {
  return (
    <div
      aria-labelledby="chatbot-header"
      className="vads-u-padding--1p5 vads-u-background-color--gray-lightest va-chatbot-chatbox"
      data-testid="chatbox-container"
      role="region"
    >
      <div className="vads-u-background-color--primary-darker vads-u-padding--1p5">
        <h2
          className="vads-u-font-size--lg vads-u-color--white vads-u-margin--0"
          id="chatbot-header"
          tabIndex="-1"
        >
          {title}
        </h2>
      </div>
      <div
        className={`vads-u-background-color--white va-chatbot-chatbox-container ${bodyClassName}`.trim()}
      >
        {children}
      </div>
    </div>
  );
}

ChatboxContainer.propTypes = {
  children: PropTypes.node.isRequired,
  bodyClassName: PropTypes.string,
  title: PropTypes.string,
};
